<template>
  <div class="delivery_order">
    <v-container grid-list-xl fluid>
      <v-layout wrap row>
        <v-flex xs12>
          <Title title="Customer Invoice">
            <div slot="widget-content">
              <div>
                <p v-if="errors.length">
                  <v-alert
                    :value="true"
                    color="primary"
                    type="error"
                    dismissible
                    outline
                  >{{ errors }}</v-alert>
                </p>

                <p v-if="pdferrors.length">
                  <v-alert
                    :value="true"
                    color="primary"
                    type="error"
                    dismissible
                    outline
                  >{{ pdferrors }}</v-alert>
                </p>
                <v-layout wrap row>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>
                      <span style="color:#0cabc2">Action</span>
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-flex xs2>
                    <v-dialog
                      v-model="new_invoice_do_dialog"
                      fullscreen
                      hide-overlay
                      transition="dialog-bottom-transition"
                    >
                      <!-- <v-btn color="primary" slot="activator">New Invoice</v-btn> -->

                      <v-card>
                        <v-toolbar dark color="primary">
                          <v-toolbar-title>New Invoice</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-toolbar-items>
                            <v-btn icon dark @click="new_invoice_do_dialog = false">
                              <v-icon>close</v-icon>
                            </v-btn>
                          </v-toolbar-items>
                        </v-toolbar>
                        <direct_customer_invoice @update="fetch_invoice_date_picker()"></direct_customer_invoice>
                      </v-card>
                    </v-dialog>
                  </v-flex>
                  <v-flex xs2>
                    <v-dialog
                      v-model="do_to_invoice_dialog"
                      fullscreen
                      hide-overlay
                      transition="dialog-bottom-transition"
                    >
                      <v-btn color="primary" slot="activator">DO to invoice</v-btn>

                      <v-card>
                        <v-toolbar dark color="primary">
                          <v-toolbar-title>DO to Invoice</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-toolbar-items>
                            <v-btn icon dark @click="do_to_invoice_dialog = false">
                              <v-icon>close</v-icon>
                            </v-btn>
                          </v-toolbar-items>
                        </v-toolbar>
                        <DoToInvoice @popup="popup" @update="fetch_invoice_date_picker()"></DoToInvoice>
                      </v-card>
                    </v-dialog>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>
                      <span style="color:#0cabc2">Previous Invoice</span>
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-flex xs9></v-flex>
                  <v-flex xs3>
                    <v-autocomplete
                      v-model="customer"
                      :items="customerList"
                      item-text="name"
                      item-value="name"
                      label="Customer"
                      persistent-hint
                      small-chips
                      solo
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                 <v-layout wrap row>
                <v-flex xs9></v-flex>
                  <v-flex xs3>
                    <v-autocomplete
                      v-model="currency"
                      :items="currencyList"
                      item-text="name"
                      item-value="value"
                      label="Currency"
                      persistent-hint
                      small-chips
                      solo
                    ></v-autocomplete>
                  </v-flex>

                </v-layout>
                <v-layout wrap row>
                  <v-flex xs6></v-flex>
                  <v-flex xs6>
                    <datepicker ref="datepicker" @update="fetch_invoice_date_picker()"></datepicker>
                  </v-flex>
                </v-layout>

                <!-- <v-flex xs12>
                  <v-select
                    v-model="selected_do_to_invoice"
                    :items="do_list_array"
                    filled
                    item-text="id"
                    label="DOxx"
                    multiple
                  >
                    <template slot="item" slot-scope="{ item }">
                      {{ item.date }} &nbsp; &nbsp;
                      {{ item.prefix_id }} &nbsp; &nbsp;
                      {{ item.driver_name }} &nbsp; &nbsp;
                    </template>
                  </v-select>
                </v-flex>-->
                <v-data-table
                  :headers="headers_invoice"
                  :items="invoice_list_array"
                  :search="customer"
                  :disable-initial-sort="true"
                  hide-actions
                  active-class="highlighted"
                  class="elevation-5"
                >
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td width="8%" class="text-xs">
                        <b>{{ props.item.date }}</b>
                      </td>
                      <td width="10%" class="text-xs">
                        <b>{{ props.item.customer_name }}</b>
                      </td>
                      <td width="5%" class="text-xs">
                        <b>{{ props.item.prefix_id }}</b>
                      </td>
                      <td width="10%" class="text-xs">
                        <b>{{ props.item.range }}</b>
                      </td>
                      <td width="15%" class="text-xs">
                        <v-layout class="ma-1">
                          <v-text-field
                            outline
                            label="Sewa Price"
                            type="number"
                            v-model="props.item.sewa_price"
                          ></v-text-field>
                          <v-btn
                            small
                            color="success"
                            outline
                            @click="update_sewa(props.item.id,props.item.sewa_price)"
                          >update</v-btn>
                        </v-layout>
                      </td>
                      <td width="20%" class="text-xs">
                        <v-btn
                          @click="fetch_sewa_for_print(props.item.id,props.item.customer_name,props.item.prefix_id, 
                         props.item.range,props.item.date)"
                        >print Sewa</v-btn>
                        <v-btn
                          @click="fetch_array_for_print(props.item.id,props.item.customer_name,props.item.prefix_id, 
                         props.item.range,props.item.date)"
                        >print Invoice</v-btn>

                        <v-btn
                          @click="fetch_array_for_statement(props.item.id,props.item.customer_name,props.item.prefix_id, 
                         props.item.range,props.item.date)"
                        >Statement</v-btn>
                      </td>
                      <td width="6%" class="text-xs">
                        <v-icon medium color="warning" @click="editItem(props.item.id,props.item.customer_id)">build</v-icon>
                        <v-icon
                          medium
                          color="error"
                          @click="delete_invoice(props.item.id)"
                        >delete_forever</v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-snackbar v-model="snackbar" :top="true">
                  No Internet Connection
                  <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
                </v-snackbar>
              </div>
            </div>
          </Title>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog_invoice_item">
      <v-card>
        <v-card-title>
          <span class="headline">Invoice Item</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 lg12 sm12 md12>
                <invoice_to_do_table ref="invoice_to_do_table"></invoice_to_do_table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="do_item_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar when axios method responsed  (jump out at bottom) -->
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="5000">
      {{response_detail}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>

    <!-- Snackbar when axios method error catched  (jump out at top) -->
    <v-snackbar v-model="snackbar_no_connection" :top="true" :timeout="6000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar_connection = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import * as jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import Title from "@/components/widget/title";
import direct_customer_invoice from "@/components/large_component/direct_customer_invoice";
import invoice_to_do_table from "@/components/large_component/invoice_to_do_table";
import DoToInvoice from "@/components/large_component/do_to_invoice";
import datepicker from "@/components/widget/datepicker";

export default {
  components: {
    //  small_list,
    Title,
    direct_customer_invoice,
    invoice_to_do_table,
    datepicker,
    DoToInvoice
  },
  data: () => ({
     currencyList:[{name:'RM',value:"RM"},{name:'SGD',value:"$"}],
    currency:'RM',
    selected_do_to_invoice: [],
    search: "",
    isLoading: true,
    snackbar: false,
    errors: "",
    pdferrors: "",
    refresh: true,
    baseUrl: baseUrl,
    date_now: moment().format("DD-MM-YYYY"),
    start_date: moment()
      .startOf("month")
      .format("YYYY-MM-DD"),
    end_date: moment().format("YYYY-MM-DD"),
    selected_customer_name: "",
    selected_customer_address: "",
    selected_driver_name: "",
    selected_do_id: "",
    VegeLogo: "",
    CheckBox: "",
    date_box: false,
    headers_invoice: [
      { text: "Date", align: "left", value: "date" },
      { text: "Customer", align: "left", value: "customer_name" },
      { text: "ID", align: "left", value: "prefix_id" },
      { text: "Range", align: "left", value: "range" },
      { text: "Sewa", align: "left", value: "sewa_price" },
      { text: "Print", align: "left", value: "" },
      { text: "Tool", align: "left", value: "" }
    ],
    date: moment().format("YYYY-MM-DD"),
    customerList: [],
    customer: "",
    do_item_dialog: false,
    headers: [
      { text: "ID", align: "", value: "prefix_id" },
      { text: "Date", align: "", value: "date" },
      { text: "Delivery Driver", align: "", value: "driver_name" }
    ],
    // tablearray: [
    //   {
    //     product_name: "",
    //     grade: "",
    //     location: "",
    //     weight: "",
    //     quantity: "",
    //     price: "",
    //     row_price: ""
    //   }
    // ],
    do_list_array: [],
    invoice_list_array: [],
    fetched_one_do_array: [],
    invoice_array_for_print: [],
    invoice_cn_array_for_print: [],
    sewa_array_for_print: [],
    prefix_id: "",
    customer_name: "",
    range: "",
    invoice_created_date: "",
    new_do_dialog: false,
    do_to_invoice_dialog: false,
    dialog_invoice_item: false,
    name: "",
    address: "",
    phone: "",
    fax: "",
    setting_grade: true,
    setting_location: true,
    setting_price: true,
    stocked_day_limit: "",
    new_invoice_do_dialog: false,
    snackbar_response: false,
    snackbar_no_connection: false,
    //others
    response: "",
    response_detail: "",
    formatted_array2:[],
    cn_fetched:false,
  }),

  computed: {},

  watch: {},

  created() {
    this.getCustomer();
    this.fetch_invoice(this.start_date, this.end_date);
    this.getImageLogo();
    this.getCompanyInfo();
  },

  methods: {
    getCustomer() {
      const params = new URLSearchParams();
      params.append("get_customer", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_customer.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.customerList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Customer List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    fetch_do: function() {
      const params = new URLSearchParams();
      params.append("getDeliveryOrderListForInvoice", "getDeliveryOrderList");
      params.append("customer_id", this.customer);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_invoice.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar = false;
            this.do_list_array = response.data.data;
            this.errors = "";
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.do_list_array = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    create_invoice: function() {
      const params = new URLSearchParams();
      params.append("createInvoice", "getDeliveryOrderList");
      params.append("customer_id", this.customer);
      params.append("do_id", this.selected_do_to_invoice);
      params.append("invoice_id", "");

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_invoice.php",
        data: params
      })
        .then(response => {
          console.log(response);

          if (response.data.error == false) {
            this.snackbar = false;
            this.do_list_array = response.data.data;
            this.fetch_invoice();
            this.errors = "";
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.do_list_array = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    fetch_invoice_date_picker() {
      this.fetch_invoice(
        this.$refs.datepicker.date1,
        this.$refs.datepicker.date2
      );
    },
    fetch_invoice: function(start_date, end_date) {
      this.do_to_invoice_dialog = false;
      const params = new URLSearchParams();
      params.append("getInvoiceList", "getInvoiceList");
      //params.append("customer_id", this.customer);

      params.append("start_date", start_date);
      params.append("end_date", end_date);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_invoice.php",
        data: params
      })
        .then(response => {
          console.log(response);
          if (response.data.error == false) {
            this.snackbar = false;
            this.invoice_list_array = response.data.data;
            this.errors = "";
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.invoice_list_array = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    get_do_detail(do_id) {
      this.$refs.do_table.getDOStock(do_id);
      this.do_item_dialog = true;
    },
    editItem(id,customer_id) {
      this.dialog_invoice_item = true;
      this.$refs.invoice_to_do_table.getInvoiceItem(id,customer_id);
    },
    fetch_array_for_print_cn(invoice_id) {
      this.invoice_cn_array_for_print = [];
     
      const params = new URLSearchParams();
      params.append("fetch_invoice_cn_array", "fetch_invoice_cn_array");
      params.append("invoice_id", invoice_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_invoice.php",
        data: params
      })
        .then(response => {
          console.log('gegee');
          console.log(response);

          this.cn_fetched=true;
          if (response.data.error == false) {
            this.snackbar = false;
            this.invoice_cn_array_for_print = response.data.data;

          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.invoice_cn_array_for_print = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    fetch_array_for_print(invoice_id, customer_name, prefix_id, range, date) {
      // this.cn_fetched=false;
      this.fetch_array_for_print_cn(invoice_id, customer_name, date);
      this.prefix_id = prefix_id;
      this.customer_name = customer_name;
      this.range = range;
      this.invoice_created_date = date;
      const params = new URLSearchParams();
      params.append("fetch_invoice_array", "fetch_invoice_array");
      params.append("invoice_id", invoice_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_invoice.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar = false;
            this.invoice_array_for_print = response.data.data;
            // this.fetch_array_for_print_cn(invoice_id, customer_name, date);

            // if(this.cn_fetched==true){
              // this.print_invoice(invoice_id, customer_name, date);
            // }
            setTimeout(()=>{
               this.print_invoice(invoice_id, customer_name, date);

            },3000);
            // var item = this.invoice_array_for_print[0].item;
            // var item2 = this.invoice_array_for_print[0].subtotal;

            // var items= item.split(';');

            //  for(var i = 0; i < items.length; i++){
            //    var name = items[i].split(',');
            //  var id = name[0];
            //   var prodcut = name[1];
            //   console.log(prodcut);
            // }
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.invoice_array_for_print = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    fetch_sewa_for_print(invoice_id, customer_name, prefix_id, range, date) {
      const params = new URLSearchParams();
      params.append("sewa", "sewa");
      params.append("invoice_id", invoice_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_invoice.php",
        data: params
      })
        .then(response => {
          console.log(response);
          if (response.data.error == false) {
            this.snackbar = false;
            this.sewa_array_for_print = response.data.data;
            // console.log( JSON.stringify( this.sewa_array_for_print));

            this.print_sewa(invoice_id, customer_name, prefix_id, range, date);
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.sewa_array_for_print = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    getImageLogo() {

      const toDataURL = url =>
        fetch(url)
          .then(response => response.blob())
          .then(
            blob =>
              new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              })
          );

      toDataURL(require("@/assets/image/vege_trading.jpg")).then(dataUrl => {
        this.VegeLogo = dataUrl;
      });

      toDataURL(require("@/assets/image/checkbox.png")).then(dataUrl => {
        this.CheckBox = dataUrl;
      });
    },
    getCompanyInfo() {
      const params = new URLSearchParams();
      params.append("get_company_info", "get_company_info");

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.name = response.data.name;
            this.address = response.data.address;
            this.phone = response.data.phone;
            this.fax = response.data.fax;
            this.setting_grade = response.data.setting_grade;
            this.setting_location = response.data.setting_location;
            this.setting_price = response.data.setting_price;
            this.stocked_day_limit = response.data.stocked_day_limit;
          } else if (response.data.error == true) {
            console.log("gg");
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    find(
      product_id,product_name,product_type,grade,location,weight,quantity,price,row_price,do_id
      ) {
      // console.log(grade);
      
      for (var g = 0; g < this.formatted_array2.length; g++) {
        console.log(this.formatted_array2[g].grade);
        if (
          this.formatted_array2[g].grade == grade &&
          this.formatted_array2[g].do_id == do_id &&
          this.formatted_array2[g].location == location &&
          this.formatted_array2[g].product_id == product_id &&
          parseFloat(this.formatted_array2[g].price).toFixed(2) == parseFloat(price).toFixed(2)
        ) {
            
          for (var j = 0; j < quantity; j++) {
            this.formatted_array2[g].weight =
            this.formatted_array2[g].weight + "," + weight;
                this.formatted_array2[g].quantity++; 
          }
                  this.formatted_array2[g].row_price =
              parseFloat(this.formatted_array2[g].row_price) +
              parseFloat(row_price);
          return;
        }
      }

      var single_weight = "";

      for (var i = 0; i < quantity; i++) {
        single_weight =
          (single_weight == "" ? "" : single_weight + ",") + weight;
      }

      for (var a = 0; a < this.formatted_array2.length; a++) {
        if(this.formatted_array2[a].do_id == do_id ){
          do_id="";
        }

      }
      this.formatted_array2.push({
  
        product_id:product_id,
        product_name: product_name,
        grade: grade,
        location: location,
        quantity: quantity,
        weight: single_weight,
        price: price,
        row_price:row_price,
        do_id:do_id,
      });


    },
    print_invoice(invoice_id, customer_name, date) {
      var doc = new jsPDF();

      // doc.addImage(this.VegeLogo, 15, 10, 23, 23);
      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(14, 15, localStorage.name);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(15, 20, localStorage.address);
      doc.text(15, 25, "Phone:" + localStorage.phone);
      doc.text(15, 30, "Fax: -" + localStorage.fax);

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(150, 15, "INVOICE: ");
      // doc.text(158, 20, "Date: ");
      doc.text(148, 25, "Customer: ");

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      doc.text(170, 15, "" + invoice_id);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      // doc.text(170, 20, this.invoice_created_date);

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      var splitTitle = doc.splitTextToSize(this.customer_name, 30);
      doc.text(170, 25, splitTitle);

      doc.setFontSize(11);
      doc.setFontStyle("normal");
      doc.text(15, 45, "Sales Bill:");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(55, 45, this.range);
      doc.setLineWidth(0.3);
      doc.line(15, 47, 192, 47);

      //////auto table
      var total = 0;
      var nextstart = 0;
      var invoice_pdf_header = [
        { header: "Invoice", dataKey: "do_id" },
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        // { header: "Grade", dataKey: "grade" },
        //{ header: "Location", dataKey: "location" },
        { header: "Weight", dataKey: "weight" },
        { header: "Qty", dataKey: "quantity" },
        { header: "Price/KG", dataKey: "price" },
        { header: "Amount", dataKey: "row_price" }
      ];

      var grade_array    =  { header: "Grade", dataKey: "grade" };
      var location_array =  { header: "Location", dataKey: "location" };

      // if (localStorage.setting_location == "true") {
      //   invoice_pdf_header.splice(3, 0, location_array);
      // }
      if (localStorage.setting_grade == "true") {
        invoice_pdf_header.splice(3, 0, grade_array);
      }

      for (var g = 0; g < this.invoice_array_for_print.length; g++) {

        var items = this.invoice_array_for_print[g].item;
        var date = this.invoice_array_for_print[g].date;

        var item = items.split(";");
        var subtotal = 0;
        var tablearray = [];
        this.formatted_array2=[];

        for (var i = 0; i < item.length; i++) {
          var veg = item[i].split(",");
          var product_id = veg[0];
          var product_name = veg[1];
          var product_type = veg[2].trim();
          var grade = veg[3];
          var location = veg[4];
          var weight = veg[5];
          var quantity = veg[6];
          var price = parseFloat(veg[7]).toFixed(2);
          var row_price = parseFloat(veg[8]).toFixed(2);
          var do_id = parseFloat(veg[9]);
 
          this.find(product_id,product_name,product_type,grade,location,weight,quantity,price,row_price,do_id);

          subtotal += parseFloat(row_price);

        }

        if (doc.autoTable.previous.finalY > 0 && doc.autoTable.previous.finalY <= 200) {
          nextstart = doc.autoTable.previous.finalY + 20;

          console.log('1');
        } else if (doc.autoTable.previous.finalY > 200) {
            doc.addPage();
            nextstart=34;
          console.log('2');

        } else {
          nextstart = 65;
          console.log('3');
        }
        doc.setFontSize(11);
        doc.setFontStyle("bold");
        doc.text(15, nextstart - 3, date);

        doc.setLineWidth(0.1);
        doc.setDrawColor(0, 0, 0);
        doc.line(15, nextstart - 1, 35, nextstart - 1);

      for (var i = 0; i < this.formatted_array2.length; i++) {
        this.$set(this.formatted_array2[i], "row_no", i + 1);
        this.formatted_array2[i].row_price=parseFloat(this.formatted_array2[i].row_price).toFixed(2);
      }

        doc.autoTable({
          pageBreak: "auto",
          startY: nextstart,
          theme: "grid",
          showHead: "firstPage",

          headStyles: {
            fillColor: [224, 224, 224],
            textColor: 10,
            fontSize: 11
          },
          didDrawPage: function(data) {
            // Header
            doc.setFontSize(20);
            doc.setTextColor(40);
            doc.setFontStyle("normal");

            // Footer
            var str = "Page " + doc.internal.getNumberOfPages();
            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === "function") {
              str = str;
            }
            doc.setFontSize(10);

            // jsPDF 1.4+ uses getWidth, <1.4 uses .width
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height
              ? pageSize.height
              : pageSize.getHeight();
            doc.text(str, 100, pageHeight - 10);
          },
          columnStyles: {
            do_id: { columnWidth: 12, fontStyle: "bold" },
            row_no: { columnWidth: 8, fontStyle: "bold" },
            product_name: { columnWidth: 15, fontStyle: "bold" },
            grade: { columnWidth: 6 },
            location: { columnWidth: 7 },
            weight: { columnWidth: 30 },
            quantity: { columnWidth: 6 },
            price: { columnWidth: 8 },
            rowprice: { columnWidth: 8, fontStyle: "bold" }
          },
          columns: invoice_pdf_header,
          body: this.formatted_array2
        });
             doc.setFontSize(12);
            doc.setFontStyle("bold");
            doc.text(
              168,
              doc.autoTable.previous.finalY + 5,
              this.currency + parseFloat(subtotal).toFixed(2)
            );
        
          var cn_print=[];

       
            for(var e=0; e<this.invoice_cn_array_for_print.length; e++){

                console.log('ada try cn');
                console.log(this.invoice_cn_array_for_print[e].date)
                console.log(date)

              if(date==this.invoice_cn_array_for_print[e].date){
                console.log('ada cn print')
                var weight=0;
                var quantity=0;
                var price=0;
                  console.log('ccnnddee1');

                  if(cn_print.length<1){
                      cn_print.push({
    
                    cn_id:this.invoice_cn_array_for_print[e].cn_id,
                    product_name:this.invoice_cn_array_for_print[e].name,
                    weight: this.invoice_cn_array_for_print[e].weight,
                    grade: this.invoice_cn_array_for_print[e].grade,
                    quantity: this.invoice_cn_array_for_print[e].quantity,
                    price: this.invoice_cn_array_for_print[e].price
                    });
                  }else{
                    for(var h=0; h<cn_print.length; h++){

                  console.log('ccnnddee2');
                  if(cn_print[h].cn_id==this.invoice_cn_array_for_print[e].cn_id){
                  console.log('ccnnddee4');

                    cn_print.push({
                    cn_id:'',
                    product_name:this.invoice_cn_array_for_print[e].name,
                    weight: this.invoice_cn_array_for_print[e].weight,
                    grade: this.invoice_cn_array_for_print[e].grade,
                    quantity: this.invoice_cn_array_for_print[e].quantity,
                    price: this.invoice_cn_array_for_print[e].price
                    });
                    break;
                  }else
                  {
                    cn_print.push({
    
                    cn_id:this.invoice_cn_array_for_print[e].cn_id,
                    product_name:this.invoice_cn_array_for_print[e].name,
                    weight: this.invoice_cn_array_for_print[e].weight,
                    grade: this.invoice_cn_array_for_print[e].grade,
                    quantity: this.invoice_cn_array_for_print[e].quantity,
                    price: this.invoice_cn_array_for_print[e].price
                    });
                    break;
                  }

                }

                  }

                

                //   cn_print.push({
    
                //   cn_id:this.invoice_cn_array_for_print[e].cn_id,
                //   product_name:this.invoice_cn_array_for_print[e].name,
                //   weight: this.invoice_cn_array_for_print[e].weight,
                //   grade: this.invoice_cn_array_for_print[e].grade,
                //   quantity: this.invoice_cn_array_for_print[e].quantity,
                //   price: this.invoice_cn_array_for_print[e].price
                // });

           
              }
            }
     
            var cn_total=0;
            for (var i = 0; i < cn_print.length; i++) {
              this.$set(cn_print[i], "row_no", i + 1);
              var rowprice=cn_print[i].weight*cn_print[i].quantity*cn_print[i].price;
              cn_total=cn_total+rowprice;
              this.$set(cn_print[i], "row_price", "-"+parseFloat(rowprice).toFixed(2));
              // this.formatted_array2[i].row_price=parseFloat(this.formatted_array2[i].row_price).toFixed(2);
            }
            var cn_pdf_header = [
                { header: "CN", dataKey: "cn_id" },
                { header: "", dataKey: "row_no" },
                { header: "Vege", dataKey: "product_name" },
                { header: "Grade", dataKey: "grade" },
                { header: "Weight", dataKey: "weight" },
                { header: "Qty", dataKey: "quantity" },
                { header: "Price/KG", dataKey: "price" },
                { header: "Amount", dataKey: "row_price" }
              ];
            if(cn_print.length>0){
              doc.autoTable({
              pageBreak: "auto",
              startY: doc.autoTable.previous.finalY+10,
              theme: "grid",
              showHead: "firstPage",

              headStyles: {
                fillColor: [224, 224, 224],
                textColor: 10,
                fontSize: 11
              },
              didDrawPage: function(data) {
                // Header
                doc.setFontSize(20);
                doc.setTextColor(40);
                doc.setFontStyle("normal");

                // Footer
                var str = "Page " + doc.internal.getNumberOfPages();
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === "function") {
                  str = str;
                }
                doc.setFontSize(10);

                // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                var pageSize = doc.internal.pageSize;
                var pageHeight = pageSize.height
                  ? pageSize.height
                  : pageSize.getHeight();
                doc.text(str, 100, pageHeight - 10);
              },
              columnStyles: {

                cn_id: { columnWidth: 12, fontStyle: "bold" },
                row_no: { columnWidth: 8, fontStyle: "bold" },
                product_name: { columnWidth: 15, fontStyle: "bold" },
                grade: { columnWidth: 6 },
                weight: { columnWidth: 30 },
                quantity: { columnWidth: 6 },
                price: { columnWidth: 8 },
                rowprice: { columnWidth: 8, fontStyle: "bold" }
              },
              columns: cn_pdf_header,
              body: cn_print
              });
            }
            

          var final_subtotal=parseFloat(subtotal)-parseFloat(cn_total);
          if(cn_print.length>0){
            doc.setFontSize(12);
            doc.setFontStyle("bold");
            doc.text(
              166,
              doc.autoTable.previous.finalY + 5,
              "-"+this.currency + parseFloat(cn_total).toFixed(2)
            );
             doc.text(
              149,
              doc.autoTable.previous.finalY + 10,
              "Subtotal:"+this.currency + parseFloat(final_subtotal).toFixed(2)
            );
          }
            

        total = total + final_subtotal;
      }
      nextstart = 0;

      //////after auto table

      if (doc.autoTable.previous.finalY > 200) {
        doc.addPage();
        doc.setFontSize(12);
        doc.setFontStyle("bold");
        doc.text(140, 20, "Total Amount:"+this.currency+ parseFloat(total).toFixed(2));

        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(15, 25, 192, 25);


        // doc.setFontSize(11);
        // doc.setFontStyle("normal");
        // doc.text(15, 31, "Notes:");
        // doc.text(15, 35, "1. All cheques should be crossed and make payable to");
        // doc.setFontStyle("bold");
        // doc.text(19, 40, "MAH SING ENTERPRISE");
        // doc.setFontStyle("bold");
        // doc.text(19, 45, "Bank Account: 3194407617(Public Bank)");
    

        // doc.setFontSize(12);
        // doc.setFontStyle("normal");
        // doc.text(140, 31, "RECIEVED:");


        doc.setLineWidth(0.1);
        doc.line(
          15,
           62,
           77,
           62
        );
        doc.setFontSize(10);
        doc.setFontStyle("bold");
        // doc.text(25, 66, "MAH SING ENTERPRISE");
        doc.text(25, 66, "Yofu Veg Trading");
        doc.line(130, 62, 192, 62);
        doc.setFontSize(10);

        doc.setFontStyle("bold");
        doc.text(133.5, 66, "CUSTOMER SIGNATURE/STAMP");

        // doc.setFontSize(10);
        // doc.setFontStyle("normal");
        // doc.text(140, 47, "Name:");
        // doc.text(140, 51, "Date:");
        
      } else {
        doc.setFontSize(12);
        doc.setFontStyle("bold");
        doc.text(
          140,
          doc.autoTable.previous.finalY + 20,
          "Total Amount:"+this.currency + parseFloat(total).toFixed(2)
        );

        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(
          15,
          doc.autoTable.previous.finalY + 25,
          192,
          doc.autoTable.previous.finalY + 25
        );

        doc.setFontSize(11);
        // doc.setFontStyle("normal");
        // doc.text(15, doc.autoTable.previous.finalY+31, "Notes:");
        // doc.text(15, doc.autoTable.previous.finalY+35, "1. All cheques should be crossed and make payable to");
        // doc.setFontStyle("bold");
        // doc.text(19, doc.autoTable.previous.finalY+40, "MAH SING ENTERPRISE");
        // doc.setFontStyle("bold");
        // doc.text(19, doc.autoTable.previous.finalY+45, "Bank Account: 3194407617(Public Bank)");


        // doc.setFontStyle("bold");
        // doc.text(42, doc.autoTable.previous.finalY+45, "Public Bank (Account No, 3194407617)");
// 
        // doc.setFontSize(11);
        // doc.text(19, doc.autoTable.previous.finalY+48, "Bank Details:");
        // doc.text(19, doc.autoTable.previous.finalY+53, "Public bank");
        // doc.text(19, doc.autoTable.previous.finalY+58, "3194407617");
        // doc.text(19, doc.autoTable.previous.finalY+63, "MAH SING ENTERPRISE");

        // doc.setFontSize(12);
        // doc.setFontStyle("normal");
        // doc.text(140, doc.autoTable.previous.finalY + 31, "RECIEVED:");

        doc.setLineWidth(0.1);
        doc.line(
          15,
          doc.autoTable.previous.finalY + 62,
          77,
          doc.autoTable.previous.finalY + 62
        );
        doc.setFontSize(10);
        doc.setFontStyle("bold");
        // doc.text(25,  doc.autoTable.previous.finalY +66, "MAH SING ENTERPRISE");
        doc.text(25,  doc.autoTable.previous.finalY +66, "Yofu Veg Trading");

        
        doc.line(
          130,
          doc.autoTable.previous.finalY + 62,
          192,
          doc.autoTable.previous.finalY + 62
        );
        doc.setFontSize(10);
        doc.setFontStyle("bold");
        doc.text(133.5,  doc.autoTable.previous.finalY +66, "CUSTOMER SIGNATURE/STAMP");

        // doc.setFontSize(10);
        // doc.setFontStyle("normal");
        // doc.text(140, doc.autoTable.previous.finalY + 47, "Name:");
        // doc.text(140, doc.autoTable.previous.finalY + 51, "Date:");
      }

      // var img = "@/assets/image/broccoli.jpeg";
      doc.autoTable.previous.finalY = 0;
      invoice_pdf_header = [
        { header: "DO", dataKey: "do_id" },
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        // { header: "Grade", dataKey: "grade" },
        //{ header: "Location", dataKey: "location" },
        { header: "Weight", dataKey: "weight" },
        { header: "Qty", dataKey: "quantity" },
        { header: "Price/KG", dataKey: "price" },
        { header: "Amount", dataKey: "row_price" }
      ];
      doc.save("C_Invoice-" + customer_name + "-" + date + ".pdf");
    },

    print_sewa(invoice_id, customer_name, prefix_id, range, date) {
      var total_sewa = 0;

      var doc = new jsPDF();
      var unifont = "xxx";
       

      // doc.addImage(this.VegeLogo, 15, 10, 23, 23);
      // // doc.addFileToVFS("@/assets/pdf_font/SimSun.ttf", SimSun);
      // doc.addFileToVFS("unifont.ttf", require("@/assets/pdf_font/unifont.ttf"));
      // doc.addFont("unifont.ttf", "unifont", "normal");

      // doc.setFont("unifont"); // set font
      // doc.setFontSize(10);
      // doc.text("你好!", 70, 15);

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(14, 15, localStorage.name);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(15, 20, localStorage.address);
      doc.text(15, 25, "Phone:" + localStorage.phone);
      doc.text(15, 30, "Fax: -" + localStorage.fax);

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(162, 15, "NO: ");
      // doc.text(158, 20, "Date: ");
      doc.text(148, 25, "Customer: ");

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      doc.text(170, 15, "#" + invoice_id);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      // doc.text(170, 20, date);

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      var splitTitle = doc.splitTextToSize(customer_name, 30);
      doc.text(170, 25, splitTitle);

      doc.setFontSize(11);
      doc.setFontStyle("normal");
      doc.text(15, 45, "Customer Vege Date(Sewa):");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(65, 45, range);
      doc.setLineWidth(0.3);
      doc.line(15, 47, 192, 47);

      //////auto table
      var total = 0;
      var nextstart = 0;
      var invoice_pdf_header = [
        { header: "Date", dataKey: "date" },
        { header: "Invoice", dataKey: "group_do_id"},
        { header: "Total KG", dataKey: "total_weight" },
        { header: "Price per KG", dataKey: "sewa_price" },
        { header: "Amount", dataKey: "sub_total" }
      ];
      console.log(JSON.stringify(this.sewa_array_for_print));
      for (var g = 0; g < this.sewa_array_for_print.length; g++) {
        var sub_total = this.sewa_array_for_print[g].sub_total;
        total_sewa = total_sewa + parseFloat(sub_total>-1?sub_total:null);
        
    
        this.sewa_array_for_print[g].sewa_price ="RM" + parseFloat(this.sewa_array_for_print[g].sewa_price).toFixed(2);
        this.sewa_array_for_print[g].total_weight = parseFloat(this.sewa_array_for_print[g].total_weight>-1?this.sewa_array_for_print[g].total_weight:'0') + "kg";
        this.sewa_array_for_print[g].sub_total ="RM" + parseFloat(this.sewa_array_for_print[g].sub_total>-1?this.sewa_array_for_print[g].sub_total:'0').toFixed(2);
      }

      console.log(total_sewa);
      doc.autoTable({
        pageBreak: "auto",
        startY: 55,
        theme: "grid",

        headStyles: {
          fillColor: [224, 224, 224],
          textColor: 10,
          fontSize: 11
        },

        columnStyles: {
          total_weight: { date: 15 },
          total_weight: { columnWidth: 30 },
          sewa_price: { columnWidth: 30 },
          sub_total: { columnWidth: 10, fontStyle: "bold", fontSize: 12 }
        },
        columns: invoice_pdf_header,
        body: this.sewa_array_for_print
      });

      //////after auto table

      if (doc.autoTable.previous.finalY > 230) {
        doc.addPage();
        doc.setFontSize(12);
        doc.setFontStyle("bold");
        doc.text(
          140,
          20,
          "Total Amount: RM" + parseFloat(total_sewa).toFixed(2)
        );

        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(15, 25, 192, 25);

        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.text(140, 31, "RECIEVED:");

        doc.setLineWidth(0.1);
        doc.line(140, 42, 192, 42);

        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(140, 47, "Name:");
        doc.text(140, 51, "Date:");
      } else {
        doc.setFontSize(12);
        doc.setFontStyle("bold");
        doc.text(
          140,
          doc.autoTable.previous.finalY + 20,
          "Total Amount: RM" + parseFloat(total_sewa).toFixed(2)
        );

        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(
          15,
          doc.autoTable.previous.finalY + 25,
          192,
          doc.autoTable.previous.finalY + 25
        );

        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.text(140, doc.autoTable.previous.finalY + 31, "RECIEVED:");

        doc.setLineWidth(0.1);
        doc.line(
          140,
          doc.autoTable.previous.finalY + 42,
          192,
          doc.autoTable.previous.finalY + 42
        );

        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(140, doc.autoTable.previous.finalY + 47, "Name:");
        doc.text(140, doc.autoTable.previous.finalY + 51, "Date:");
      }

      // var img = "@/assets/image/broccoli.jpeg";
      doc.autoTable.previous.finalY = 0;
      doc.save("C_Invoice(sewa)-" + customer_name + "-" + date + ".pdf");
    },

    popup(e) {
      console.log("hahaa");
      console.log(e);
      this.snackbar_response = true;
      this.response_detail = e;
    },

    delete_invoice(invoice_id) {
      if (confirm("Delete invoice and release the stock?")) {
        const params = new URLSearchParams();
        params.append("delete_invoice", "delete_invoice");
        params.append("invoice_id", invoice_id);

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/stock/customer_invoice.php",
          data: params
        })
          .then(response => {
            if (response.data.error == false) {
              this.snackbar_response = true;
              this.response_detail = response.data.message;
              this.fetch_invoice(
                this.$refs.datepicker.date1,
                this.$refs.datepicker.date2
              );
            } else if (response.data.error == true) {
              this.snackbar_response = true;
              this.response_detail = response.data.message;
            }
          })
          .catch(error => {
            console.log(error);
            this.snackbar = true;
          });
      }
    },

    update_sewa(invoice_id, sewa_price) {
      const params = new URLSearchParams();
      params.append("UpdateSewaPrice", "UpdateSewaPrice");
      params.append("invoice_id", invoice_id);
      params.append("sewa_price", sewa_price);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_invoice.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.fetch_invoice(
              this.$refs.datepicker.date1,
              this.$refs.datepicker.date2
            );
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },

    fetch_array_for_statement(invoice_id, customer_name, prefix_id, range, date) {
      this.prefix_id = prefix_id;
      this.customer_name = customer_name;
      this.range = range;
      this.invoice_created_date = date;
      const params = new URLSearchParams();
      params.append("fetch_invoice_array", "fetch_invoice_array");
      params.append("invoice_id", invoice_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_invoice.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar = false;
            this.invoice_array_for_print = response.data.data;
           
            this.fetch_array_for_print_cn(invoice_id);

            setTimeout(()=>{
                this.print_statement(invoice_id, customer_name, date);
            },2000);
            // var item = this.invoice_array_for_print[0].item;
            // var item2 = this.invoice_array_for_print[0].subtotal;

            // var items= item.split(';');

            //  for(var i = 0; i < items.length; i++){
            //    var name = items[i].split(',');
            //  var id = name[0];
            //   var prodcut = name[1];
            //   console.log(prodcut);
            // }
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.invoice_array_for_print = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },

    print_statement(invoice_id, customer_name, date) {
      var doc = new jsPDF();

      // doc.addImage(this.VegeLogo, 15, 10, 23, 23);
      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(14, 15, localStorage.name);


      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(15, 20, localStorage.address);
      doc.text(15, 25, "Phone:" + localStorage.phone);
      doc.text(15, 30, "Fax: -" + localStorage.fax);

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(162, 15, "NO: ");
      doc.text(158, 20, "Date: ");
      doc.text(148, 25, "Customer: ");

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      doc.text(170, 15, "#" + invoice_id);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(170, 20, this.invoice_created_date);

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      var splitTitle = doc.splitTextToSize(this.customer_name, 30);
      doc.text(170, 25, splitTitle);

      doc.setFontSize(11);
      doc.setFontStyle("normal");
      doc.text(15, 45, "Statement:");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(55, 45, this.range);
      doc.setLineWidth(0.3);
      doc.line(15, 47, 192, 47);

      //////auto table
      var total = 0;
      var nextstart = 0;
      var invoice_pdf_header = [
        { header: "No", dataKey: "row_no" },
        { header: "Date", dataKey: "date" },
        { header: "DO", dataKey: "do_id" },
        { header: "Subtotal", dataKey: "subtotal" },
        { header: "", dataKey: "cn" },
        { header: "Amount", dataKey: "amount" },
       
      ];
      var statement_array=[];

      for (var g = 0; g < this.invoice_array_for_print.length; g++) {

        var items = this.invoice_array_for_print[g].item;
        var date = this.invoice_array_for_print[g].date;

        var item = items.split(";");
        var subtotal = 0;
        var tablearray = [];
        this.formatted_array2=[];

        for (var i = 0; i < item.length; i++) {

          var veg = item[i].split(",");
          var product_id = veg[0];
          var product_name = veg[1];
          var product_type = veg[2].trim();
          var grade = veg[3];
          var location = veg[4];
          var weight = veg[5];
          var quantity = veg[6];
          var price = parseFloat(veg[7]);
          var row_price = parseFloat(veg[8]).toFixed(2);
          var do_id = parseFloat(veg[9]);

          this.find(product_id,product_name,product_type,grade,location,weight,quantity,price,row_price,do_id);
          
          subtotal += parseFloat(row_price);

        }

  
          nextstart = 55;
          console.log('3');
        
        // doc.setFontSize(11);
        // doc.setFontStyle("bold");
        // doc.text(15, nextstart - 3, date);

        // doc.setLineWidth(0.1);
        // doc.setDrawColor(0, 0, 0);
        // doc.line(15, nextstart - 1, 35, nextstart - 1);

      var do_id_stack=[];
      for (var i = 0; i < this.formatted_array2.length; i++) {
        // this.$set(this.formatted_array2[i], "row_no", i + 1);
        // this.formatted_array2[i].row_price=parseFloat(this.formatted_array2[i].row_price).toFixed(2);
            if(this.formatted_array2[i].do_id!==''){
                do_id_stack.push(this.formatted_array2[i].do_id);
            } 
          
          // for (var i = 0; i < statement_array.length; i++) {
          //   this.$set(statement_array[i], "row_no", i + 1);
              
          // }
          
          // doc.setFontSize(12);
          // doc.setFontStyle("bold");
          // doc.text(
          //   15,
          //   nextstart + 5,
          //   this.currency + parseFloat(subtotal).toFixed(2)
          // );
         

      }
       statement_array.push({
            date:date,
            do_id: do_id_stack,
            subtotal: parseFloat(subtotal).toFixed(2),
            cn: '',
            amount: parseFloat(subtotal).toFixed(2),
          });
          
      }
        console.log(statement_array);
      for(var b=0; b<statement_array.length; b++){

        this.$set(statement_array[b], "row_no", b + 1);
              var cn_amount=0;

        for(var e=0; e<this.invoice_cn_array_for_print.length; e++){

              if(statement_array[b].date==this.invoice_cn_array_for_print[e].date){
                var cn_weight=0;
                var cn_quantity=0;
                var cn_price=0;

                cn_weight=this.invoice_cn_array_for_print[e].weight;
                cn_quantity=this.invoice_cn_array_for_print[e].quantity;
                cn_price=this.invoice_cn_array_for_print[e].price;
                console.log('cn apa ');
                cn_amount=cn_amount+(parseFloat(cn_weight)*parseFloat(cn_quantity)*parseFloat(cn_price));
              }
            } 
              console.log('eedf ');
         
            var final_amount=parseFloat(statement_array[b].subtotal)-parseFloat(cn_amount);
                if(cn_amount!==0){
                statement_array[b].cn="-"+(parseFloat(cn_amount).toFixed(2));
                  
                }else{
                  statement_array[b].cn="";

                }
              

                
                statement_array[b].amount=this.currency +parseFloat(final_amount).toFixed(2);

                total = total + final_amount;


      }
        console.log(statement_array);




       doc.autoTable({
          pageBreak: "auto",
          startY: nextstart,
          theme: "grid",
          showHead: "firstPage",

          headStyles: {
            fillColor: [224, 224, 224],
            textColor: 10,
            fontSize: 11
          },
          didDrawPage: function(data) {
            // Header
            doc.setFontSize(20);
            doc.setTextColor(40);
            doc.setFontStyle("normal");
           
          },
          columnStyles: {
            row_no: { columnWidth: 10, fontStyle: "bold" },
            date: { columnWidth: 20, fontStyle: "bold" },
            do_id: { columnWidth: 50, fontStyle: "bold" },
            subtotal: { columnWidth: 20, fontStyle: "bold" },
            cn: { columnWidth: 20, fontStyle: "bold" },
            amount: { columnWidth: 20, fontStyle: "bold" },
          },
          columns: invoice_pdf_header,
          body: statement_array
        });
      // nextstart = 0;

      //////after auto table

      if (doc.autoTable.previous.finalY > 250) {
        doc.addPage();
        doc.setFontSize(12);
        doc.setFontStyle("bold");
        doc.text(140, 20, "Total Amount:"+this.currency+ parseFloat(total).toFixed(2));

      } else {
        doc.setFontSize(12);
        doc.setFontStyle("bold");
        doc.text(
          140,
          doc.autoTable.previous.finalY + 20,
          "Total Amount:"+this.currency + parseFloat(total).toFixed(2)
        );

        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(
          15,
          doc.autoTable.previous.finalY + 25,
          192,
          doc.autoTable.previous.finalY + 25
        );

      
      }

      // var img = "@/assets/image/broccoli.jpeg";
      // nextstart = 0;

      doc.save("C_Invoice-" + customer_name + "-" + date + ".pdf");
    },
  },
  mounted() {
    // Run the functions once when mounted
    // Run the intervalFetchData function once to set the interval time for later refresh
  }
};
</script>

